import React from 'react';
import { Box, Container } from '@mui/material';
import Header from './Header';
import Footer from './Footer';

/**
 * Main layout component that wraps all pages
 */
class Layout extends React.Component {
  render() {
    const { children } = this.props;
    
    return (
      <Box sx={{ 
        display: 'flex', 
        flexDirection: 'column', 
        minHeight: '100vh',
        position: 'relative',
        paddingBottom: { xs: '72px', sm: '80px' } // Space for footer
      }}>
        <Header />
        <Container component="main" sx={{ flexGrow: 1, py: 4 }}>
          {children}
        </Container>
        <Footer />
      </Box>
    );
  }
}

export default Layout;
